import { FAVORITE_RESCUES_STORAGE_KEY } from '../constants';
import type { FrictionSubtype, InterruptionSource, Ping, PingType, RescueKind } from '../types';

export type RecentPingContext = {
  subtype: FrictionSubtype | null;
  interruptionSource: InterruptionSource | null;
};

export function listFavoriteRescues(storage: Pick<Storage, 'getItem'> = localStorage): RescueKind[] {
  const raw = storage.getItem(FAVORITE_RESCUES_STORAGE_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isRescueKind);
  } catch {
    return [];
  }
}

export function toggleFavoriteRescue(
  kind: RescueKind,
  storage: Pick<Storage, 'getItem' | 'setItem'> = localStorage
): RescueKind[] {
  const current = listFavoriteRescues(storage);
  const next = current.includes(kind) ? current.filter((item) => item !== kind) : [...current, kind].slice(0, 3);
  storage.setItem(FAVORITE_RESCUES_STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function recentContextForPingType(pings: Ping[], pingType: PingType | null, currentPingId?: string | null): RecentPingContext | null {
  if (!pingType) return null;
  const recent = pings.find(
    (ping) =>
      ping.type === pingType &&
      ping.id !== currentPingId &&
      (ping.subtype !== null || ping.interruption_source !== null)
  );
  if (!recent) return null;
  return {
    subtype: recent.subtype,
    interruptionSource: recent.interruption_source
  };
}

function isRescueKind(value: unknown): value is RescueKind {
  return (
    value === 'reset_2m' ||
    value === 'make_smaller_10m' ||
    value === 'focus_25m' ||
    value === 'breathe_90s' ||
    value === 'brain_dump_2m' ||
    value === 'walk_5m' ||
    value === 'stand_water' ||
    value === 'one_sentence'
  );
}
